let adhibition = {
    title: "Application center",
    accountNumber: "Select login Account",
    subusername: "Account number",
    multifactorAuthentication: "Multifactor authentication",
    subusernameMsg: "Please select a subaccount",
    authentication: "Authentication",
    authentications: "Login",
    noData:"No data",
    apply:"Apply for application",
    applyApp:"Apply for application",
    selectAppType:"Select application",
    pendApproval:"Pending approval",
    refused:"Refused",
    applyReasonRequire:"You need to be approved by the administrator to have access to the application. Please fill in the application reason.",
    noRequireReason:"The application can be applied successfully without approval.",
    applyReason:"Reason for application",
    placePutReason:"Please fill in the application reason, no more than 200 words",
    pleaseSelectType:"Please select application!",
    pleaseApplyReason:"Please enter the application reason!",
    applyReasonMaxLength:"The application reason cannot exceed 200 words!",
    downZip:"Download client plug-in",
   removeApp:'Remove app',
    downSAP:{
        des:'When receiving the browser prompt, click "Open XXX" to call up the client',
        noTip:"If you do not receive a prompt, please install it first",
        plugIn:"Client plug-in",
    },
    appGroup:{
        addGroup:"Add Group",
        editGroup:"Modify grouping",
        sureDeleteGroup:"Are you sure to delete this grouping?",
        selectBrowser:"Please select the browser to open the application",
        noData:"No data",
        edit:"Revise",
        delete:"Delete",
        groupName:"Group name",
        requireGroupName:"Group name cannot be empty",
        maxGroupName:"Group name cannot exceed 20 characters",
        whole:"whole",

    },
    browserList:{
      'firefox':"Mozilla Firefox",
      'qq':"QQ Browser",
      'sogou':"Sogou Browser",
      'safety360':"360 Safety Browser",
      'safety360Speed':"360 Extreme Explorer",
    }
}

export default adhibition
